import { Component, OnInit, NgZone } from '@angular/core';

interface WindowStatus { [key: string]: number; }
interface MachineStatus {
  topic: string;
  data: WindowStatus;
  order: string[];
}

interface MFMData {
  topic: string;
  data: any;
  timestamp?: string;
}

@Component({
  selector: 'app-annunciator',
  templateUrl: './annunciator.component.html',
  styleUrls: ['./annunciator.component.scss']
})
export class AnnunciatorComponent implements OnInit {
  private ws!: WebSocket;
  public isData = false;
  public machines: { [key: string]: MachineStatus } = {};
  public editingWindow: { machineId: string | null; key: string | null } = { machineId: null, key: null };

  // MFM Data properties
  public showMFMView = false;
  public mfmData: { [key: string]: MFMData } = {};
  public selectedMFM: string | null = null;
  public mfmTopics = ['MFM/1/Data', 'MFM/2/Data', 'MFM/3/Data', 'MFM/4/Data',
    'MFM/5/Data', 'MFM/6/Data', 'MFM/7/Data', 'MFM/8/Data',
    'MFM/9/Data', 'MFM/10/Data', 'MFM/11/Data'];
  public mfmNames: { [key: string]: string } = {
    '1': '132/33KV PTR-1 HV',
    '2': '132/33KV PTR-1 LV',
    '3': '132/33KV PTR-2 HV',
    '4': '132/33KV PTR-2 LV',
    '5': '33KV Bus Section',
    '6': '33KV Surabardi',
    '7': '33KV Lava',
    '8': '33KV Gondakhairi',
    '9': '33KV Amravati R.O',
    '10': '33KV FDR 5',
    '11': '33KV FDR 6'
  };
  private slaveNames: { [id: number]: string } = {
    1: '168-33KV FDR 1-4',
    2: '169-33KV FDR 5-6 + B.S.',
    3: '171-132/33KV TF No.2',
    4: '172-132/33KV TF No.1'
  };

  constructor(private ngZone: NgZone) { }

  private slaveWindowMappings: { [id: number]: { [W: string]: string } } = {
    168: {
      W1: "F-1 O/C+E/F PROTN OPTD",
      W2: "F-1 86 TRIP RELAY OPTD",
      W3: "F-1 TC-1 FAULTY",
      W4: "F-1 TC-2 FAULTY",
      W5: "F-2 O/C+E/F PROTN OPTD",
      W6: "F-2 86 TRIP RELAY OPTD",
      W7: "F-2 TC-1 FAULTY",
      W8: "F-2 TC-2 FAULTY",
      W9: "F-1 / F-2 MFM DC FAIL",
      W10: "F-1 / F-2 BCU DC FAIL",
      W11: "F-1 O/C+E/F RLY DC FAIL",
      W12: "F-2 O/C+E/F RLY DC FAIL",
      W13: "F-3 O/C+E/F PROTN OPTD",
      W14: "F-3 86 TRIP RELAY OPTD",
      W15: "F-3 TC-1/2 FAULTY",
      W16: "F-4 O/C+E/F PROTN OPTD",
      W17: "F-4 86 TRIP RELAY OPTD",
      W18: "F-4 TC-1/2 FAULTY",
      W19: "F-3 / 4 MFM DC FAIL",
      W20: "F-3/4 O/C+E/F RLY DC FAIL"
    },
    169: {
      W1: "F-5 O/C+E/F PROTN OPTD",
      W2: "F-5 86 TRIP RELAY OPTD",
      W3: "F-5 TC-1 FAULTY",
      W4: "F-5 TC-2 FAULTY",
      W5: "F-6 O/C+E/F PROTN OPTD",
      W6: "F-6 86 TRIP RELAY OPTD",
      W7: "F-6 TC-1 FAULTY",
      W8: "F-6 TC-2 FAULTY",
      W9: "F-5 / F-6 MFM DC FAIL",
      W10: "F-5 / F-6 BCU DC FAIL",
      W11: "F-5 O/C+E/F RLY DC FAIL",
      W12: "F-6 O/C+E/F RLY DC FAIL",
      W13: "B.S. O/C+E/F PROTN OPTD",
      W14: "B.S. 86 TRIP RELAY OPTD",
      W15: "B.S. TC-1 FAULTY",
      W16: "B.S. TC-2 FAULTY",
      W17: "B.S. O/C+E/F RLY DC FAIL",
      W18: "B.S. MFM+ PT SEL. FAIL",
      W19: "B.S. BCU DC FAIL",
      W20: ""
    },
    171: {
      W1: "BUCHHOLZ ALARM",
      W2: "WTI ALARM",
      W3: "OTI ALARM",
      W4: "MOG ALARM",
      W5: "BUCHHOLZ TRIP",
      W6: "WTI TRIP",
      W7: "OTI TRIP",
      W8: "OSR TRIP",
      W9: "PRD TRIP",
      W10: "HV B/U OPTD",
      W11: "DIFF. PROTN. OPTD",
      W12: "HV LBB OPTD",
      W13: "TC FAULTY HV",
      W14: "TC FAULTY LV",
      W15: "LV B/U OPTD",
      W16: "LV LBB OPTD",
      W17: "86 GRP A TRIP",
      W18: "86 GRP B TRIP",
      W19: "HV DC FAIL",
      W20: "LV DC FAIL"
    },
    172: {
      W1: "BUCHHOLZ ALARM",
      W2: "WTI ALARM",
      W3: "OTI ALARM",
      W4: "MOG ALARM",
      W5: "BUCHHOLZ TRIP",
      W6: "WTI TRIP",
      W7: "OTI TRIP",
      W8: "OSR TRIP",
      W9: "PRD TRIP",
      W10: "HV B/U OPTD",
      W11: "DIFF. PROTN. OPTD",
      W12: "HV LBB OPTD",
      W13: "TC FAULTY HV",
      W14: "TC FAULTY LV",
      W15: "LV B/U OPTD",
      W16: "LV LBB OPTD",
      W17: "86 GRP A TRIP",
      W18: "86 GRP B TRIP",
      W19: "HV DC FAIL",
      W20: "LV DC FAIL"
    }
  };

  ngOnInit() {
    //this.ws = new WebSocket('ws://localhost:8080/ws/annunciator');
this.ws = new WebSocket('wss://api.trafobola.com');
    this.ws.onopen = () => {
      console.log('✅ WebSocket connected');
      console.log('🎧 Listening for all topics from backend...');
    };

    this.ws.onerror = (err) => {
      console.error('❌ WebSocket error', err);
    };

    this.ws.onclose = () => {
      console.log('🔌 WebSocket closed');
    };

    this.ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        const topic = message.topic || '';

        

        // Handle MFM data - exact match
        if (topic.startsWith('MFM/') && topic.endsWith('/Data')) {
          console.log('🎯 MFM Topic Detected:', topic);

          try {
            const parsedData = JSON.parse(message.data || '{}');
            console.log('📊 MFM Parsed Data:', parsedData);

            this.ngZone.run(() => {
              const mfmId = topic.split('/')[1];
              console.log('💾 Storing MFM data for ID:', mfmId);

              this.mfmData[mfmId] = {
                topic: topic,
                data: parsedData,
                timestamp: new Date().toLocaleString()
              };

              console.log('✅ MFM Data stored successfully for MFM', mfmId);
              console.log('   Data:', this.mfmData[mfmId]);
              console.log('📋 Total MFM devices with data:', Object.keys(this.mfmData).length);
            });
          } catch (parseError) {
            console.error('❌ Error parsing MFM data:', parseError);
          }

          return; // Don't process as machine data
        }

        // Existing machine logic
        const machineId = ((topic).split('/')[1] || '').toString();

        if (!['1', '2', '3', '4'].includes(machineId)) {
          return;
        }

        const raw = JSON.parse(message.data || '{}');
        const converted = this.convertResponse(raw);
        this.isData = true;

        this.ngZone.run(() => {
          const current = this.machines[machineId];
          if (current) {
            Object.keys(current.data).forEach(k => {
              if (!(k in converted.data)) {
                delete current.data[k];
              }
            });
            Object.keys(converted.data).forEach(k => current.data[k] = converted.data[k]);
            current.order = converted.order;
            current.topic = message.topic;
          } else {
            this.machines[machineId] = {
              topic: message.topic,
              data: { ...converted.data },
              order: [...converted.order]
            };
          }
        });
      } catch (e) {
        console.error('❌ Failed to parse WS message', e);
      }
    };
  }

  getMachineDisplayName(machine: any): string {
    const name = this.slaveNames[machine] || 'Unknown';
    return name;
  }
  getMFMName(id: string): string {
    return this.mfmNames[id] || `MFM ${id}`;
  }
  private convertResponse(raw: any): { data: WindowStatus; order: string[]; slave_id?: number; status?: string } {
    const slaveId = raw.slave_id;
    const mapping = this.slaveWindowMappings[slaveId];
    const data: WindowStatus = {};
    const order: string[] = [];

    if (mapping) {
      for (let i = 1; i <= 20; i++) {
        const wKey = 'window' + i;
        const mapKey = 'W' + i;
        const name = mapping[mapKey];
        if (name && raw.hasOwnProperty(wKey)) {
          data[name] = raw[wKey];
          order.push(name);
        }
      }
    } else {
      for (let i = 1; i <= 20; i++) {
        const wKey = 'window' + i;
        if (raw.hasOwnProperty(wKey)) {
          data[wKey] = raw[wKey];
          order.push(wKey);
        }
      }
    }

    return { data, order, slave_id: raw.slave_id, status: raw.status };
  }

  startEditing(machineId: string, windowKey: string) {
    this.editingWindow = { machineId, key: windowKey };
    setTimeout(() => {
      const input = document.querySelector('.window-name-edit:focus') as HTMLInputElement | null;
      if (input) input.select();
    }, 0);
  }

  updateWindowName(machineId: string, oldKey: string, newName: string) {
    if (!newName) {
      this.editingWindow = { machineId: null, key: null };
      return;
    }
    newName = newName.trim();
    if (!newName) {
      this.editingWindow = { machineId: null, key: null };
      return;
    }

    const machine = this.machines[machineId];
    if (!machine) return;

    if (oldKey === newName) {
      this.editingWindow = { machineId: null, key: null };
      return;
    }

    if (machine.data.hasOwnProperty(newName)) {
      let idx = 1;
      let candidate = `${newName} (${idx})`;
      while (machine.data.hasOwnProperty(candidate)) {
        idx++;
        candidate = `${newName} (${idx})`;
      }
      newName = candidate;
    }

    const val = machine.data[oldKey];
    machine.data[newName] = val;
    const pos = machine.order.indexOf(oldKey);
    if (pos > -1) machine.order[pos] = newName;
    delete machine.data[oldKey];

    this.editingWindow = { machineId: null, key: null };
  }

  trackByMachine(_: number, item: { key: string; value: MachineStatus }) {
    return item.key;
  }

  trackByWindow(_: number, key: string) {
    return key;
  }

  // MFM Functions
  toggleMFMView() {
    this.showMFMView = !this.showMFMView;
    if (!this.showMFMView) {
      this.selectedMFM = null;
    }
  }

  selectMFM(mfmId: string) {
    this.selectedMFM = mfmId;
  }

  closeMFMDetails() {
    this.selectedMFM = null;
  }

  getObjectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  formatValue(value: any): string {
    if (typeof value === 'number') {
      return value.toFixed(2);
    }
    if (value !== null && value !== undefined) {
      return value.toString();
    }
    return 'N/A';
  }

  getMFMStatus(mfmId: string): string {
    return this.mfmData[mfmId] ? 'Active' : 'Inactive';
  }
}